<template>
    <div style="z-index: 11">
        <v-menu
            offset-y
            v-model="menuOpen"
            max-width="512px"
            :min-width="state.isMobile ? '90dvw' : '400px'"
            :close-on-content-click="false"
            :close-on-click="closeOnOutsideClick"
        >
            <template v-slot:activator="{ on, attrs }">
                <button class="share-button" v-bind="attrs" v-on="on" :disabled="disabled" v-if="mode === 'button'">
                    <span>Share </span>
                    <span class="divider"></span>
                    <font-awesome-icon icon="fa-solid fa-caret-down"></font-awesome-icon>
                </button>
                <v-list-item v-on="on" class="share-list-item" v-else>
                    <font-awesome-icon class="share-icon mr-2" icon="fa-share"></font-awesome-icon>
                    <span class="share-text">Share </span>
                </v-list-item>
            </template>
            <v-card v-click-outside="handleClickOutside">
                <v-tabs v-model="tabIndex" color="#ee5207" grow dense>
                    <v-tab v-for="(tab, index) in shareTabs" :ripple="false" :key="index">{{
                        state.isMobile && tab.tabTitleMobile ? tab.tabTitleMobile : tab.tabTitle
                    }}</v-tab>
                </v-tabs>
                <p v-if="shareTabs[tabIndex].linkType === 'Family' && !hasCompletedVideo" 
                    class="p-2 m-2 orange lighten-3 rounded"
                    style="font-size: 0.9rem;"
                >
                    *This link works best on a computer or in our mobile app.
                </p>
                <p v-if="state.isFuneralHomeAdmin && !tributeVideo.submissionsOpen && shareTabs[tabIndex].linkType !== 'Completed video' && !hasCompletedVideo" 
                    class="p-3 m-2 mb-1 red lighten-4 rounded"
                    style="font-size: 0.9rem;"
                >
                    *Submissions are currently closed, users won't be able to upload media
                </p>
                <v-tabs-items v-model="tabIndex">
                    <v-tab-item v-for="(tab, index) in shareTabs" :value="index">
                        <v-list class="sharing-menu">
                            <v-list-item :key="tab.link">
                                <v-list-item-title class="font-weight-bold">{{ tab.linkTitle }}</v-list-item-title>
                                <v-list-item-subtitle style="white-space: normal">
                                    {{ tab.linkSubtitle }}
                                </v-list-item-subtitle>
                                <v-list-item-subtitle>
                                    <v-text-field
                                        outlined
                                        dense
                                        class="has-addon__right"
                                        prepend-inner-icon="mdi-account-group-outline"
                                        v-model="tab.link"
                                        readonly
                                    >
                                        <v-btn
                                            :disabled="tab.link === '...'"
                                            depressed
                                            slot="append-outer"
                                            @click="copyToClipboard(tab.linkType, tab.link)"
                                        >
                                            <font-awesome-icon
                                                class="mr-2"
                                                icon="fa-regular fa-clone"
                                            ></font-awesome-icon>

                                            Copy</v-btn
                                        >
                                    </v-text-field>
                                </v-list-item-subtitle>
                            </v-list-item>
                            <hr class="m-2" />

                            <v-list-item>
                                <v-list-item-title class="font-weight-bold">Send Email or SMS</v-list-item-title>
                                <v-list-item-subtitle> Send this link via email or sms </v-list-item-subtitle>
                                <EmailSmsLink
                                    :ref="`share-input-${index}`"
                                    v-if="menuOpen"
                                    @change="val => handleInvitesChange(val)"
                                    @submit="data => tab.shareCallback(data)"
                                    :link="tab.link"
                                >
                                    <template #append-outer="{ submit, listLength }">
                                        <v-btn
                                            style="background-color: rgba(251, 140, 0, 0.15); color: rgb(251, 140, 0)"
                                            @click="submit"
                                            depressed
                                            :disabled="isSendLinkDisabled(listLength, tab.linkType)"
                                            >Send</v-btn
                                        >
                                    </template>
                                </EmailSmsLink>
                            </v-list-item>

                            <template v-if="!state?.isFamily && !state?.isContributor">
                                <hr class="m-2" v-if="tab.linkType === 'Family' || tab.linkType === 'Contributor'" />

                                <v-list-item v-if="tab.linkType === 'Family' || tab.linkType === 'Contributor'">
                                    <v-list-item-title class="font-weight-bold"
                                        >Share QR Code</v-list-item-title
                                    >
                                    <v-list-item-subtitle>
                                        View, print or download the {{ tab.linkType.toLowerCase() }} share link as a QR
                                        Code</v-list-item-subtitle
                                    >
                                    <div class="d-flex share-buttons">
                                        <v-btn
                                            :disabled="loading"
                                            :loading="loading"
                                            @click="$root.$emit('show-scan-modal', tab.linkType); menuOpen = false"
                                            depressed
                                            color="orange accent-2"
                                        >
                                            Show
                                        </v-btn>
                                        <v-btn
                                            :disabled="loading"
                                            :loading="loading"
                                            @click="downloadPdf(tab.linkType)"
                                            depressed
                                            color="light-blue accent-2"
                                        >
                                            Print
                                        </v-btn>
                                        <v-btn
                                            :disabled="loading"
                                            :loading="loading"
                                            @click="downloadQrAsImage(tab.linkType)"
                                            depressed
                                            color="purple lighten-3"
                                        >
                                            Download
                                        </v-btn>
                                    </div>
                                </v-list-item>
                            </template>
                        </v-list>
                    </v-tab-item>
                </v-tabs-items>
                <qrcode-vue
                    class="qr-render"
                    ref="qrcode-family"
                    background="#f8f8f8"
                    :value="familyShareLink"
                    :key="familyShareLink"
                    size="230"
                    render-as="svg"
                />
                <qrcode-vue
                    class="qr-render"
                    ref="qrcode-contributor"
                    background="#f8f8f8"
                    :value="contributorLink"
                    :key="contributorLink"
                    size="230"
                    render-as="svg"
                />
            </v-card>
        </v-menu>
        <qr-printout
            ref="contributorQrPrint"
            v-if="tributeVideo && service && tributeVideo.deeplink"
            title="Tribute Video"
            :service="service"
            :link="tributeVideo.deeplink"
            @loading="val => (loading = val)"
        />

        <qr-printout
            ref="familyQrPrint"
            v-if="tributeVideo && service && tributeVideo.familyLink"
            title="Tribute Video"
            :service="service"
            :link="tributeVideo.familyLink"
            @loading="val => (loading = val)"
        />
    </div>
</template>
<script>
import { mapActions } from 'pinia';
import EmailSmsLink from '@/components/ui/EmailSmsLink.vue';
import TributeVideoService from '@/services/tributeVideo.service';
import ServicesService from '@/services/services.service';
import QrPrintout from '@/components/ManageService/Tribute/QrPrintout.vue';
import QrcodeVue from 'qrcode.vue';
import { startCase } from 'lodash';
import { useTributeVideoStore } from '@/stores/tributeVideo';
import { useGlobalState } from '@/stores/globalState';

export default {
    setup() {
        return {
            tributeVideoStore: useTributeVideoStore(),
        }
    },
    data() {
        return {
            menuOpen: false,
            tabIndex: 0,
            tributeApi: null,
            serviceApi: null,
            token: null,
            currentInvites: [],
            service: null,
            loading: false,
        };
    },
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        mode: {
            type: String,
            default: 'button',
        },
    },
    components: { EmailSmsLink, QrPrintout, QrcodeVue },
    computed: {
        isSendLinkDisabled() {
            return (listLength, linkType) => {
                return listLength === 0 || (linkType === 'Completed video' && this.completedVideoLink === '...');
            };
        },
        shareTabs() {
            const familyOrContributor = this.state?.isContributor || this?.state.isFamily;
            var tabs = [
                {
                    tabTitle: familyOrContributor ? 'Collect Memories' :
                        this.completedVideoLink === '...' ? 'Upload Only' : 'Video Only',
                    tabTitleMobile: familyOrContributor ? 'Collect Memories' :
                        this.completedVideoLink === '...' ? 'Upload Only' : 'Video Only',
                    linkTitle: 'Share Link',
                    linkSubtitle: familyOrContributor
                        ? 'Share with family and friends to collect their photos'
                        : 'Contribute photos and videos to the tribute.',
                    link: this.contributorLink,
                    linkType: 'Contributor',
                    contributorVisible: true,
                    familyVisible: true,
                    postRender: false,
                    shareCallback: this.handleInviteSubmit,
                },
                {
                    tabTitle: this.completedVideoLink === '...' ? 'Full Access' : 'Photos & Video',
                    tabTitleMobile: this.completedVideoLink === '...' ? 'Full Access' : 'Photos & Video',
                    linkTitle: 'Share Link',
                    linkSubtitle: 'Full creative access — upload media, select themes, and music.',
                    link: this.familyShareLink,
                    linkType: 'Family',
                    familyVisible: false,
                    contributorVisible: false,
                    postRender: false,
                    shareCallback: this.handleInviteSubmit,
                },
                {
                    tabTitle: 'Tribute Video',
                    linkTitle: 'Share Completed Tribute Video',
                    linkSubtitle: 'Allow anyone with the link to view the tribute video.',
                    link: this.completedVideoLink,
                    linkType: 'Completed video',
                    familyVisible: true,
                    contributorVisible: true,
                    postRender: true,
                    shareCallback: this.handleTributeVideoShare,
                },
            ];

            if (this.state) {
                if (this.state.isContributor) {
                    tabs = tabs.filter(tab => tab.contributorVisible);
                }
    
                if (this.state.isFamily) {
                    tabs = tabs.filter(tab => tab.familyVisible);
                }
                // Submissions closed and completed video 
                if (this.completedVideoLink === '...') {
                    tabs = tabs.filter(tab => !tab.postRender);
                }
            }
            return tabs;
        },
        familyShareLink() {
            return this.tributeVideoStore.familyLink || '...';
        },
        contributorLink() {
            return this.tributeVideoStore.deeplink || '...';
        },
        hasCompletedVideo() {
            return this.tributeRender?.standardRender?.url?.length;
        },
        completedVideoLink() {
            // TODO: Figure out where the completed video link lives
            if (this.tributeRender?.standardRender?.url) {
                return `${process.env.VUE_APP_VIDEO}/video/${this.$route.params.slug}/tribute-video`;
            }

            return '...';
        },
        tributeVideoId() {
            return this.tributeVideoStore.id;
        },
        closeOnOutsideClick() {
            return this.currentInvites.length === 0;
        },
        tributeVideo() {
            return this.tributeVideoStore;
        },
        shareLink() {
            if (this.state.isContributor && this.tributeVideoStore.deeplink?.length) {
                return this.contributorLink;
            }
            if (this.state.isFamily && this.tributeVideoStore.familyLink?.length) {
                return this.familyShareLink;
            }
            return null;
        },
    },
    inject: ['tributeRender', 'state'],
    watch: {
        tabIndex(newVal, oldVal) {
            this.resetShareInput(oldVal);
        },
        menuOpen(newVal) {
            if (!newVal) {
                this.resetShareInput(this.tabIndex);
            }
        },
        tributeVideoId(newVal) {
            if (newVal && !this.service) {
                if (this.tributeVideo.serviceId) {
                    this.getTributeService(this.tributeVideo.serviceId);
                }
            }
        },
    },
    methods: {
        ...mapActions(useGlobalState, ['showSnackbar']),
        downloadPdf(type) {
            let ref;

            type = type.toLowerCase();

            if (type === 'family') {
                ref = this.$refs.familyQrPrint;
            } else if (type === 'contributor') {
                ref = this.$refs.contributorQrPrint;
            }

            if (!ref || typeof ref.generatePdf != 'function') {
                this.showSnackbar({
                    message: 'An error occurred during pdf generation',
                    color: 'error',
                });
                return;
            }

            this.menuOpen = false;
            ref.generatePdf();
        },
        downloadQrAsImage(tabType) {
            const ref = this.$refs[`qrcode-${tabType.toLowerCase()}`];

            if (ref) {
                const svgEl = ref.$el.querySelector('svg');
                const svgData = new XMLSerializer().serializeToString(svgEl);
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                const img = new Image();

                img.onload = () => {
                    canvas.width = img.width;
                    canvas.height = img.height;
                    ctx.drawImage(img, 0, 0);
                    canvas.toBlob(blob => {
                        const link = document.createElement('a');
                        link.href = URL.createObjectURL(blob);
                        link.download = `${
                            startCase(this.service.firstName) + ' ' + startCase(this.service.lastName)
                        } Tribute QR Code.png`;
                        link.click();
                        URL.revokeObjectURL(link.href);
                    }, 'image/png');
                };

                img.src = 'data:image/svg+xml;base64, ' + btoa(svgData);
            }
        },
        resetShareInput(index) {
            this.currentInvites = [];
            const targetInput = this.$refs[`share-input-${index}`];
            if (targetInput?.length) {
                const ref = targetInput[0];
                if (ref) {
                    ref.reset();
                }
            }
        },
        handleInvitesChange(val) {
            this.currentInvites = val;
        },
        handleClickOutside() {
            if (!this.closeOnOutsideClick) {
                this.showSnackbar({
                    message: 'Please send or clear invites to close menu',
                    color: 'error',
                });
            }
        },
        copyToClipboard(type, link) {
            // TODO: browser support for this is really good, but need to double check if a fallback is needed
            navigator.clipboard.writeText(link);
            this.showSnackbar({
                message: `${type} link copied.`,
            });
            this.sharingMenuOpen = false;
        },
        handleInvalidEmail(email) {
            this.showSnackbar({ message: `${email} is not a valid email`, color: 'error' });
        },
        async handleInviteSubmit(contacts) {
            let data = {
                emailList: contacts.emailList.join(','),
                phoneList: contacts.phoneList.join(','),
                url: contacts.url,
            };

            try {
                await this.tributeApi.invite(this.tributeVideoId, data);
                this.showSnackbar({ message: 'Invitations sent' });
                this.resetShareInput(this.tabIndex);
                this.menuOpen = false;
            } catch (error) {
                console.log(error, 'error during invite submit');
                if (error?.response?.status === 401) {
                    this.showSnackbar({ message: 'Unauthorized access', color: 'error' });
                } else {
                    this.showSnackbar({ message: 'Error sending invitations', color: 'error' });
                }
            }
        },
        async handleTributeVideoShare(contacts) {
            let data = {
                emailList: contacts.emailList.join(','),
                phoneList: contacts.phoneList.join(','),
                url: contacts.url,
            };

            try {
                await this.tributeApi.shareFinalVideo(this.tributeVideoId, data);
                this.showSnackbar({ message: 'Invitations sent' });
                this.menuOpen = false;
            } catch (error) {
                console.log(error, 'error during invite submit');
                if (error.response.status === 401) {
                    this.showSnackbar({ message: 'Unauthorized access', color: 'error' });
                } else {
                    this.showSnackbar({ message: 'Error sending invitations', color: 'error' });
                }
            }
        },
        async getTributeService(serviceId) {
            try {
                const resp = await this.serviceApi.get(serviceId);

                if (resp.data) {
                    this.service = resp.data;
                }
            } catch (error) {
                console.log(error, 'error');
            }
        },
        async setAuthToken() {
            const response = await this.$auth.getIdTokenClaims();
            this.token = response.__raw;
        },
    },
    async mounted() {
        if (this.state.token) {
            this.token = this.state.token;
        } else {
            await this.setAuthToken();
        }
        this.tributeApi = TributeVideoService(this.token);
        this.serviceApi = ServicesService(this.token);

        if (this.tributeVideo.serviceId) {
            this.getTributeService(this.tributeVideo.serviceId);
        }
    },
};
</script>
<style lang="scss" scoped>
.share-button {
    padding: 0.5rem 1rem;
    font-weight: 500;
    background-color: $primary-orange;
    color: white;
    border-radius: 0.375rem;
    display: flex;
    align-items: center;
    gap: 8px;

    &:disabled {
        cursor: not-allowed;
        opacity: 0.6;
    }
}

.sharing-menu {
    padding: 1.5rem 0.5rem;
    display: flex;
    flex-direction: column;

    .v-list-item {
        display: inline-block;
        padding: 0.5rem;
    }

    .v-list-item__title {
        font-weight: 500;
    }

    .v-list-item__title,
    .v-list-item__subtitle {
        margin: 4px 0;
        line-height: 1.3;
    }

    ::v-deep {
        .v-input.has-addon__right {
            .v-input__slot {
                margin: 0;
            }

            .v-input__control {
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
                fieldset {
                    border-color: #ccc;
                    border-right: transparent;
                }
            }

            .v-input__append-outer {
                margin: 0 !important;

                button {
                    border-top-left-radius: 0;
                    border-bottom-left-radius: 0;
                    border: 1px solid #ccc;
                    height: 40px;
                    text-transform: none;
                }
            }
        }
    }
}

.share-button .divider {
    width: 1px;
    height: 20px;
    background-color: white;
    margin-left: 8px;
}

.share-list-item {
    .share-icon {
        color: $medium-gray;
    }
    .share-text {
        color: $deep-gray;
    }
}
@media only screen and (max-width: 1200px) {
    .with-family-text {
        display: none;
    }
}
.share-buttons {
    gap: 4px; 
    
    .v-btn {
        flex: 1;
    }
}
.qr-render {
    display: none;
}
</style>
